import { gql } from "@apollo/client";

export const BrandFragment = gql`
    fragment Brand on Brand {
        id
        name
        shortName
        logoPath
        logoGrayscalePath
        logoTransparentPath
        logoTransparentBackgroundColor
    }
`;

export const brandSelectionQuery = gql`
    query BrandSelection {
        brands {
            nodes {
                ...Brand
            }
            totalCount
        }
    }
    ${BrandFragment}
`;
